import { createRoot } from 'react-dom/client';
import { App } from './app.js';
import { UpdateBanner } from './update-banner.js';
import { FlashHost } from './flash.js';
import { registerServiceWorker } from './sw-register.js';
import { startTracking } from './track.js';
import './fonts.css';
import './styles.css';

// Отчёт владельцу: сбои и уход со страницы ловятся с первой секунды.
startTracking();

const root = document.getElementById('root');
if (!root) throw new Error('Не нашёл #root');
createRoot(root).render(<><App /><UpdateBanner /><FlashHost /></>);
registerServiceWorker();
